import {
  configurationLucideIconProps,
  getConfigurationCustomIconStrokeWidth,
  getNavigationCustomIconStrokeWidth,
  getTopNavCustomIconStrokeWidth,
  navigationLucideIconProps,
  topNavLucideIconProps,
} from "@dashboard/components/icons";

const MODELING_VIEWBOX_SIZE = 20;
const modelingStrokeWidth = getNavigationCustomIconStrokeWidth(MODELING_VIEWBOX_SIZE);
const configurationModelingStrokeWidth =
  getConfigurationCustomIconStrokeWidth(MODELING_VIEWBOX_SIZE);
const topNavModelingStrokeWidth = getTopNavCustomIconStrokeWidth(MODELING_VIEWBOX_SIZE);

const ModelingIconPaths = ({ strokeWidth }: { strokeWidth: number }) => (
  <>
    <path
      d="M7.5 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V7.5C2.5 8.42047 3.24619 9.16667 4.16667 9.16667H7.5C8.42047 9.16667 9.16667 8.42047 9.16667 7.5V4.16667C9.16667 3.24619 8.42047 2.5 7.5 2.5Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0417 2.5H13.9584C13.3831 2.5 12.9167 2.96637 12.9167 3.54167V5.625C12.9167 6.2003 13.3831 6.66667 13.9584 6.66667H16.0417C16.617 6.66667 17.0834 6.2003 17.0834 5.625V3.54167C17.0834 2.96637 16.617 2.5 16.0417 2.5Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83331 9.16663V12.5C5.83331 12.942 6.00891 13.3659 6.32147 13.6785C6.63403 13.991 7.05795 14.1666 7.49998 14.1666H10.8333"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8333 10.8334H12.5C11.5795 10.8334 10.8333 11.5796 10.8333 12.5V15.8334C10.8333 16.7538 11.5795 17.5 12.5 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8334V12.5C17.5 11.5796 16.7538 10.8334 15.8333 10.8334Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10.8333V7.5"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
);

export const ModelingIcon = (): JSX.Element => (
  <svg
    width={navigationLucideIconProps.size}
    height={navigationLucideIconProps.size}
    viewBox={`0 0 ${MODELING_VIEWBOX_SIZE} ${MODELING_VIEWBOX_SIZE}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ModelingIconPaths strokeWidth={modelingStrokeWidth} />
  </svg>
);

export const ConfigurationModelingIcon = (): JSX.Element => (
  <svg
    width={configurationLucideIconProps.size}
    height={configurationLucideIconProps.size}
    viewBox={`0 0 ${MODELING_VIEWBOX_SIZE} ${MODELING_VIEWBOX_SIZE}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ModelingIconPaths strokeWidth={configurationModelingStrokeWidth} />
  </svg>
);

export const TopNavModelingIcon = (): JSX.Element => (
  <svg
    width={topNavLucideIconProps.size}
    height={topNavLucideIconProps.size}
    viewBox={`0 0 ${MODELING_VIEWBOX_SIZE} ${MODELING_VIEWBOX_SIZE}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ModelingIconPaths strokeWidth={topNavModelingStrokeWidth} />
  </svg>
);
